// MoneyZakatTable.js
import React from 'react';
function MoneyZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th > Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Kewajiban zakat	</td>
          <td>{result.zakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        <tr >
          <td>Nisab zakat harta</td>
          <td>{result.threshold} </td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari uang)</td>
          <td>{result.zakat} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default MoneyZakatTable;